<template>
  <Breadcrumbs
      title="Create New User"
      :breadcrumbs="[
      { label: 'Master Data', path: '' },
      { label: 'Users', path: '/users' },
      { label: 'Create New User', path: '/create-user' },
    ]"
  />

  <div class="container-fluid">
    <div class="row project-cards">
      <newUserForm/>
    </div>
  </div>
</template>


<script>

import newUserForm from './newUserForm.vue';

export default {
  components: {
    newUserForm
  }
}

</script>